import React from 'react';
import { useFeatureValue } from '@shared/core/featureFlags';
import { UpdatedContent } from './Content';
import { LegacyContent } from './LegacyContent';

interface Props
  extends Readonly<{
    isOpen: boolean;
    onClose: () => void;
  }> {}

export const PrintEarlyAccessDialog: React.FC<Props> = props => {
  const shouldShowTreatmentContent = useFeatureValue('printDashboardEarlyAccessDialogV2').value === 'treatment';

  return shouldShowTreatmentContent ? <UpdatedContent {...props} /> : <LegacyContent {...props} />;
};
